import { HTMLProps, PropsWithChildren } from 'react'
import classes from './CustomerVisibleIndicator.module.scss'
import clsx from 'clsx'

type Props = {
  suppressTooltip?: boolean
  isRequiredField?: boolean
  title?: string
  isChildTask?: boolean
}

const icon = (
  <svg
    className={classes['svg']}
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill=" #1C8A86"
  >
    <path d="M480-304 304-480l176-176 176 176-176 176Zm56 199q-11 11-26 17t-30 6q-15 0-30-6t-26-17L105-424q-11-11-17-26t-6-30q0-15 6-30t17-26l318-318q12-12 26.5-18t30.5-6q16 0 30.5 6t26.5 18l318 318q11 11 17 26t6 30q0 15-6 30t-17 26L536-105Zm-56-87 288-288-288-288-288 288 288 288Z" />
  </svg>
)

export const CustomerVisibilityLegend = () => (
  <div className={classes['customer-indicator-container']}>
    {icon}
    <span className={classes['indicator-text']}>- This information is visible to customers.</span>
  </div>
)

const CustomerVisibleIndicator = (props: PropsWithChildren<Props>) => {
  const isChildTask = props.isChildTask ?? false

  return (
    <span
      className={clsx(
        { [classes['container']]: !isChildTask },
        { [classes['container-child-task']]: isChildTask === true }
      )}
      title={
        props.suppressTooltip && !props.title
          ? undefined
          : (props.title ?? 'This information is visible to customers.')
      }
    >
      <span className={classes['children']}>{props.children}</span>{' '}
      {props.isRequiredField && <span className={classes['required-indicator']}>*</span>} {icon}
    </span>
  )
}

export default CustomerVisibleIndicator
